import React from "react";
import {Route, Routes} from "react-router-dom";
import {AuthLayout} from "./AuthLayout";
import {EmployeeNumberFP} from "../pages/authentication/forgotPassword/EmployeeNumberFP";
import {OneTimePinFP} from "../pages/authentication/forgotPassword/OneTimePinFP";
import {CreatePasswordFP} from "../pages/authentication/forgotPassword/CreatePasswordFP";
import {SuccessFP} from "../pages/authentication/forgotPassword/SuccessFP";
import {PinVerifyFP} from "../pages/authentication/forgotPassword/PinVerifyFP";


export const UnAuthenticatedRoutesForgotPassword = () => {
    return (
        <AuthLayout>
            <Routes>
                {/*====== Forgot Password =======*/}
                <Route path="/employee-number" element={<EmployeeNumberFP />} />
                <Route path="/one-time-password" element={<OneTimePinFP />} />
                <Route path="/verify-account-pin" element={<PinVerifyFP />} />
                <Route path="/create-password" element={<CreatePasswordFP />} />
                <Route path="/success" element={<SuccessFP />} />
            </Routes>
        </AuthLayout>
    )
}